import Card from "..\\..\\..\\..\\src\\components\\card\\brief";
import TrialList from "..\\..\\..\\..\\src\\components\\card\\trial-list";
import * as React from 'react';
export default {
  Card,
  TrialList,
  React
};